import React from "react";
import styles from "./SelectionLayer.module.css";

const SelectionLayer = ({ end, start }) =>
	start &&
	end && (
		<div
			className={styles.selectionRectangle}
			style={{
				top: Math.min(start.top, end.top),
				left: Math.min(start.left, end.left),
				height: Math.abs(end.top - start.top),
				width: Math.abs(end.left - start.left),
			}}
		/>
	);

export default SelectionLayer;
